(function ($, Drupal, window, document, undefined) {
  function initBarNav(selector = ".bar-nav") {
    const els = [...document.querySelectorAll(selector)]
    els.length &&
      els.forEach(
        el =>
          new Accordion(el, {
            itemSelector: ".bar-nav__li > button",
            contentSelector: ".bar-nav__sub-list-wrap",
            link: true,
          })
      )
  }

  function initMegaMenu() {
    $(document).ready(function() {
      let gsapAnim = gsap.timeline();
      let isAnyMenuOpen = false;

      // Set initial state for all mega menu items
      $(".mega-menu-item").css({display: "none", opacity: 0});

      // on interaction
      $("#block-megamenu .bar-nav__li > .inline-dropdown-button, .megamenu-init .bar-nav__li > .inline-dropdown-button").click(function(e) {
        let gsapAnim = gsap.timeline();

        // expand only if it's closed
        if ($(this).attr("data-active") == "false") {
          // get data attr control for which menu item
          var dataControl = $(this).attr('data-controls');

          // If no menu is open, use fade animation
          if (!isAnyMenuOpen) {
            // reset all menu header items
            $("#block-megamenu .bar-nav__li > .inline-dropdown-button, .megamenu-init .bar-nav__li > .inline-dropdown-button").attr("data-active", "false");
            $(this).attr("data-active", "true");

            $(dataControl).show().css({opacity: 0});
            gsapAnim.to(dataControl, {
              opacity: 1,
              duration: 0.3,
              ease: "power2.inOut"
            });
          } else {
            // If a menu is already open, switch immediately without animation
            $(".mega-menu-item").hide();
            $("#block-megamenu .bar-nav__li > .inline-dropdown-button, .megamenu-init .bar-nav__li > .inline-dropdown-button").attr("data-active", "false");
            $(this).attr("data-active", "true");
            $(dataControl).show().css({opacity: 1});
          }

          isAnyMenuOpen = true;
        }
        // close if it's already open
        else {
          // close menu header item
          $(this).attr("data-active", "false");
          // fade out all menu items
          gsapAnim.to(".mega-menu-item", {
            opacity: 0,
            duration: 0.2, // Changed from 0.3 to 0.2 for faster closing
            ease: "power2.inOut",
            onComplete: () => {
              $(".mega-menu-item").hide();
            }
          });
          isAnyMenuOpen = false;
        }
      });
    });
  }

  function initMegaMenuMobile() {

    $(document).ready(function() {
      var dataControl;
      // add data attribute for control
      $(".mega-menu-item-mobile .menu-mega__menu > ul li a").attr("data-active", "false");
      // menu open close behaviour
      $(".mega-menu-item-mobile .menu-header-icon").click(function(e) {
        // get button state
        let activeState = $(this).prevAll('a').attr("data-active");
        // set menu target to expand
        let menuEl = $(this).prev();
        // open if not expanded, close if expanded;
        if (activeState == 'false') {
          $(this).prevAll('a').attr("data-active", "true");
          menuEl.animate({ maxHeight: '600px' }, 900);
        } else {
          $(this).prevAll('a').attr("data-active", "false");
          menuEl.animate({ maxHeight: '0' }, 100);
        }
      });

      // 1st level menu behaviour
      // get which menu item we want to slide in
      $(".mega-menu-header-mobile .menu-header-icon").click(function(e) {
        // get controller
        dataControl = ('block-').concat($(this).prev().attr("data-controls").replace('#', '')).concat('-mobile');
        // do the sliding in
        $('.menu__nav').toggleClass('mega-menu-child-hidden');
        $('#' + dataControl).toggleClass('mega-menu-child-show');
      });

      // 1st level back button
      $(".mega-menu-back-button").click(function(e) {
        // hide
        $('.menu__nav').toggleClass('mega-menu-child-hidden');
        $('#' + dataControl).toggleClass('mega-menu-child-show');
      });


    });
  }

  initBarNav()
  initMegaMenu()
  initMegaMenuMobile()
}(jQuery, Drupal, this, this.document))
